import gql from 'graphql-tag'

export const ADD_REQ_OGV = gql`
  mutation addRequestOGR($object: [ongoing_feedback_requests_insert_input!]!) {
    insert_ongoing_feedback_requests(objects: $object) {
      affected_rows
    }
  }
`
